import { Button, CheckIcon, CompareIcon } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { MouseEvent } from 'react';

import styles from './compareToggle.module.css';

interface CompareToggleProps {
  isSelected: boolean;
  onToggle: () => void;
  productName: string;
}

export const CompareToggle = ({
  isSelected,
  onToggle,
  productName,
}: CompareToggleProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onToggle();
  };

  return (
    <Button.Icon
      className={clsx(styles['toggle'], {
        [styles['toggle__active']]: isSelected,
      })}
      icon={isSelected ? <CheckIcon size="sm" /> : <CompareIcon size="sm" />}
      onClick={handleClick}
      aria-label={`Compare ${productName}`}
      aria-pressed={isSelected}
    />
  );
};
